import { request } from "../../../lib/requestHelper";

export const fetchPosts = async(activeTab,searchParams) => {
    const params = new URLSearchParams(searchParams);

  if (activeTab) {
    params.set("tab", activeTab);
  }

  return await request(`api/fetch-posts?${params.toString()}`, {
    method: "GET",
  });
};

export const savePost = async(postId)=>{
    return await request(`api/save-post`, {
        method: "POST",
        body: JSON.stringify({postId})
    });
}


export const unsavePost = async(postId)=>{
    return await request(`api/unsave-post`, {
        method: "POST",
        body: JSON.stringify({postId})
    });
}

export const fetchSavedPosts = async()=>{
    return await request(`api/fetch-saved-post`, {
        method: "GET",
    });
}

export const newPost = async(formData)=>{
    return await request(`api/post`, {
        method: "POST",
        body: formData
    });
}

export const fetchSubscribedPostsApi = async(activeTab,followedFilters)=>{
    const params = new URLSearchParams(followedFilters);

  if (activeTab) {
    params.set("tab", activeTab);
  }
    return await request(`artisan/fetch-posts?${params.toString()}`, {
        method: "GET",
    });
}

export const fetchArtisanPostsApi = async(artisanId)=>{
    return await request(`artisan/fetch-posts/${artisanId}`, {
        method: "GET",
    });
}

export const deleteArtisanPostApi = async(postId)=>{
    return await request(`artisan/delete-post/${postId}`, {
        method: "DELETE",
    });
}

export const fetchArtisanFollowersApi = async () => {
    return await request(`artisan/fetch-followers`, {
        method: "GET",
    });
};

export const fetchSuggestedJobsApi = async () => {
  return await request('api/fetch-suggested-jobs');
};

export const fetchRecentClientsApi = async () => {
  return await request('artisan/fetch-recent-clients');
};